import React, { useState } from "react";
import Loader from "./Loader";
import { Link } from "react-router-dom";

const Login = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(
        "https://espacioanalogico.com.ar/api/login.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
          credentials: "include",
        },
      );

      const data = await response.json();

      if (data.success) {
        onLoginSuccess(true);
      } else {
        setError(data.message || "Email o contraseña incorrectos");
      }
    } catch (err) {
      console.error("Error en login:", err);
      setError("Error de conexión con el servidor");
    } finally {
      setLoading(false);
    }
  };

  if (loading)
    return (
      <div className="mt-5 text-center">
        <Loader />
      </div>
    );

  return (
    <div className="login-container mt-5">
      <div className="d-flex justify-content-center mb-4">
        <Link to="/">
          {/* Asegurate de que ean.jpg esté en la carpeta /public */}
          <img src="/ean.jpg" width="200" alt="logo" />
        </Link>
      </div>

      <div className="d-flex justify-content-center">
        <form
          onSubmit={handleLogin}
          className="p-4 border rounded shadow-sm bg-white"
          style={{ width: "350px" }}
        >
          <h3 className="text-center mb-4">Admin Espacio</h3>

          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Contraseña</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && (
            <div className="alert alert-danger p-2 text-center small">
              {error}
            </div>
          )}

          <button type="submit" className="boton w-100 mt-2">
            Ingresar
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
